import { render, staticRenderFns } from "./ProductUnits.vue?vue&type=template&id=94a33c06&"
import script from "./ProductUnits.vue?vue&type=script&lang=js&"
export * from "./ProductUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports